import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import numeral from "numeral"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import HomeSalesLotType from "/widgets/homeSalesMonthLotType"
import HomeSalesBuilder from "/widgets/homeSalesMonthBuilder"
import HomeSalesLotTypeBuilder from "/widgets/homeSalesMonthLotTypeBuilder"
import HomeSalesSectionBuilder from "/widgets/homeSalesMonthSectionBuilder"

class SalesAnalysis extends Component {
	//todo This can be cleaned up a bit when there's time.  DRY
	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "Builder",
					accessor: "builder",
					name: "Builder",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					name: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
					name: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
					name: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					name: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					display: true,
					name: "Neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Address",
					accessor: "address",
					display: true,
					name: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					display: true,
					name: "Contract Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Price",
					accessor: "price",
					display: true,
					name: "Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (!v.price) {
								return
							}
							total += v.price
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `$${average}`
					},
				},
				{
					Header: "Sq. Ft.",
					accessor: "sqft",
					display: true,
					name: "Sq. Ft.",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("0,0")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (!v.sqft) {
								return
							}
							total += v.sqft
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `${average}`
					},
				},
				{
					Header: "$ per Sq. Ft.",
					accessor: "ppsqft",
					display: true,
					name: "$ per Sq. Ft.",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0.00")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.ppsqft
							count++
						})
						let average = (total / count).toFixed(2).toLocaleString()
						return `$${average}`
					},
				},
				{
					Header: "Beds",
					accessor: "beds",
					display: true,
					name: "Beds",
				},
				{
					Header: "Baths",
					accessor: "baths",
					display: true,
					name: "Baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
					display: true,
					name: "Garage",
				},
				{
					Header: "Site Type",
					accessor: "site_type",
					display: true,
					name: "Site Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "site_type"),
				},

				{
					Header: "ISD",
					accessor: "isd",
					display: true,
					name: "ISD",
					filterMethod: (f, r) => helpers.tableText(f, r, "isd"),
				},
				/* {
					Header: "Lot Price",
					accessor: "lot_price",
					display: true,
					name: "Lot Price",
					Cell: (v) => {
						if (v.value) {
							let val = v.value
							val = parseFloat(val)
							return `$${val.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.lot_price
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `$${average}`
					},
				}, */
				{
					Header: "% Lot Price / Home Price",
					accessor: "percent_lot",
					display: true,
					name: "% Lot Price / Home Price",
					Cell: (v) => {
						if (v.value) {
							let val = v.value
							val = parseFloat(val)
							return `${val.toLocaleString(undefined, {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}%`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.percent_lot
							count++
						})
						let average = (total / count).toFixed(2).toLocaleString()
						return `${average}%`
					},
				},
				{
					Header: "Community",
					accessor: "community",
					display: true,
					name: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Closed Date",
					accessor: "closed_date",
					display: true,
					name: "Closed Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
			],
			grossColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					name: "Builder",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					name: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
					name: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
					name: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					name: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					display: true,
					name: "Neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Address",
					accessor: "address",
					display: true,
					name: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					display: true,
					name: "Contract Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Price",
					accessor: "price",
					display: true,
					name: "Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (!v.price) {
								return
							}
							total += v.price
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `$${average}`
					},
				},
				{
					Header: "Sq. Ft.",
					accessor: "sqft",
					display: true,
					name: "Sq. Ft.",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("0,0")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (!v.sqft) {
								return
							}
							total += v.sqft
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `${average}`
					},
				},
				{
					Header: "$ per Sq. Ft.",
					accessor: "ppsqft",
					display: true,
					name: "$ per Sq. Ft.",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0.00")
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.ppsqft
							count++
						})
						let average = (total / count).toFixed(2).toLocaleString()
						return `$${average}`
					},
				},
				{
					Header: "Beds",
					accessor: "beds",
					display: true,
					name: "Beds",
				},
				{
					Header: "Baths",
					accessor: "baths",
					display: true,
					name: "Baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
					display: true,
					name: "Garage",
				},
				{
					Header: "Site Type",
					accessor: "site_type",
					display: true,
					name: "Site Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "site_type"),
				},

				{
					Header: "ISD",
					accessor: "isd",
					display: true,
					name: "ISD",
					filterMethod: (f, r) => helpers.tableText(f, r, "isd"),
				},
				/* {
					Header: "Lot Price",
					accessor: "lot_price",
					display: true,
					name: "Lot Price",
					Cell: (v) => {
						if (v.value) {
							let val = v.value
							val = parseFloat(val)
							return `$${val.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.lot_price
							count++
						})
						let average = Math.round(total / count).toLocaleString()
						return `$${average}`
					},
				}, */
				{
					Header: "% Lot Price / Home Price",
					accessor: "percent_lot",
					display: true,
					name: "% Lot Price / Home Price",
					Cell: (v) => {
						if (v.value) {
							let val = v.value
							val = parseFloat(val)
							return `${val.toLocaleString(undefined, {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}%`
						}
						return ""
					},
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							total += v.percent_lot
							count++
						})
						let average = (total / count).toFixed(2).toLocaleString()
						return `${average}%`
					},
				},
				{
					Header: "Community",
					accessor: "community",
					display: true,
					name: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Cancel Date",
					accessor: "cancel_date",
					display: true,
					name: "Cancel Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closed Date",
					accessor: "closed_date",
					display: true,
					name: "Closed Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
			],
			underContractColumns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "sectionName",
					filterMethod: (f, r) => helpers.tableText(f, r, "sectionName"),
				},
				{
					Header: "Block",
					accessor: "block",
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Price",
					accessor: "price",
					display: true,
					name: "Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => helpers.tableTotals(props, "price", "$0,0"),
				},
				{
					Header: "Sales Person",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Contract Date",
					accessor: "contract_date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Estimated Closed Date",
					accessor: "estimated_closing",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Buyer Last",
					accessor: "buyer_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
				},
			],
			dirtBreakout: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Dirt",
					accessor: "dirt",
					Footer: (props) => helpers.tableTotals(props, "dirt", "0,0"),
				},
				{
					Header: "Specs",
					accessor: "specs",
					Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
				},
			],
			dirtCommunity: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Dirt",
					accessor: "dirt",
					Footer: (props) => helpers.tableTotals(props, "dirt", "0,0"),
				},
				{
					Header: "Specs",
					accessor: "specs",
					Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
				},
			],
			homePriceColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					display: true,
					name: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					display: true,
					name: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
					name: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
					name: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					name: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Address",
					accessor: "address",
					display: true,
					name: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Sale Status",
					accessor: "sale_status",
					display: true,
					name: "Sale Status",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_status"),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					display: true,
					name: "Closing Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Sale Price",
					accessor: "sale_price",
					display: true,
					name: "Sale Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "sale_price", "0,0"),
				},
				{
					Header: "Closing Price",
					accessor: "closing_price",
					display: true,
					name: "Closing Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "closing_price", "0,0"),
				},
				{
					Header: "Home SF",
					accessor: "home_sf",
					display: true,
					name: "Home SF",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("0,0")
						}
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "home_sf", "0,0"),
				},
				{
					Header: "Price per SF",
					accessor: "price_per_sf",
					display: true,
					name: "Price per SF",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0.00")
						}
						return ""
					},
					exportFormatting: (v) => {
						if (v) {
							return numeral(v).format("0,0.00")
						}
						return ""
					},
					Footer: (props) => helpers.tableAverages(props, "price_per_sf", "0,0"),
				},
			],
			lotSaleDetail: [
				{
					Header: "Builder",
					accessor: "builder",
					display: true,
					name: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					display: true,
					name: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					display: true,
					name: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					display: true,
					name: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Address",
					accessor: "address",
					display: true,
					name: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Takedown Date",
					accessor: "takedown_date",
					display: true,
					name: "Takedown Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Start Date",
					accessor: "start_date",
					display: true,
					name: "Start Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Complete Date",
					accessor: "complete_date",
					display: true,
					name: "Complete Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Buyer Name",
					accessor: "buyer_name",
					name: "buyer_name",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_name"),
				},
				{
					Header: "Buyer Email",
					accessor: "buyer_email",
					name: "buyer_email",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_email"),
				},
				{
					Header: "Buyer Zip",
					accessor: "buyer_zip",
					name: "buyer_zip",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_zip"),
				},
				{
					Header: "Sales Rep",
					accessor: "sales_rep",
					display: true,
					name: "Sales Rep",
					filterMethod: (f, r) => helpers.tableText(f, r, "sales_rep"),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					display: true,
					name: "Sale Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Sale Price",
					accessor: "sale_price",
					display: true,
					name: "Sale Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
				},
				{
					Header: "Realtor Name",
					accessor: "realtor_name",
					name: "realtor_name",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_name"),
				},
				{
					Header: "Realtor Office",
					accessor: "realtor_office",
					name: "realtor_office",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_office"),
				},
				{
					Header: "Realtor Phone",
					accessor: "realtor_phone",
					name: "realtor_phone",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_phone"),
				},
				{
					Header: "Realtor License",
					accessor: "realtor_license",
					name: "realtor_license",
					display: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_license"),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					display: true,
					name: "Closing Date",
					Cell: (v) => {
						if (v.value) {
							return moment.unix(v.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Closing Price",
					accessor: "closing_price",
					display: true,
					name: "Closing Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return ""
					},
				},
			],
			grossFiltered: [],
			filtered: [],
			grossSorted: [],
			sorted: [],
			showFilters: false,
			showGrossFilters: false,
		}
	}

	underContract = () => {
		let ret = []
		_.forEach(this.props.payload.exec.sales, (r) => {
			if (!r.closing_date && !r.bustout_date && !r.cancel_date && !r.transfer_date) {
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				let row = {
					builder: builder ? builder.name : "",
					salesperson: sp ? `${sp.first} ${sp.last}` : "",
					sectionName: r.sectionName,
					block: r.block,
					lot: r.lot,
					price: r.price,
					lot_type: type?.name || "",
					address: r.address,
					contract_date: r.sale_date || "",
					estimated_closing: r.estimated_closing || "",
					buyer_last: r.primary_last,
				}
				ret.push(row)
			}
		})
		return ret
	}

	grossSupply = () => {
		let ret = []
		_.forEach(this.props.payload.sales.current, (r) => {
			if (!r.builder || r.transfer_date) {
				return
			}

			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (!builder) {
				return
			}
			let lot = _.find(this.props.payload.exec.lots, { id: r.lot_id })
			if (!lot) {
				return
			}
			let site = _.find(this.props.payload.public.sites, { id: lot.site_id })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: lot.neighborhood })
			let community = _.find(this.props.payload.public.properties, { id: r.property })
			let section = _.find(this.props.payload.public.sections, { id: lot.section_id })
			let sectionName = ""
			if (section) {
				sectionName = section.name
			}
			let isd = _.find(this.props.payload.public.isds, { id: r.isd })
			if (isd) {
				isd = isd.code
			}
			let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			if (type) {
				type = type.name
			}
			ret.push({
				builder: builder.name,
				base_price: r.base_price ? r.base_price : 0,
				price: r.price ? r.price : 0,
				sqft: r.sqft ? r.sqft : 0,
				ppsqft: r.sqft && r.price ? r.price / r.sqft : 0,
				beds: lot.beds,
				baths: lot.full_baths,
				address: lot.address,
				garage: lot.garage,
				lot: lot.lot,
				block: lot.block,
				site_type: site ? site.name : "",
				lot_price: lot.base_price,
				neighborhood: neighborhood ? neighborhood.name : "",
				percent_lot: r.price && lot.base_price ? (lot.base_price / r.price) * 100 : 0,
				community: community ? community.name : "",
				contract_date: r.sale_date,
				closed_date: r.closing_date || null,
				cancel_date: r.bustout_date ? r.bustout_date : "",
				section: sectionName,
				isd,
				lot_type: type,
			})
		})
		return ret
	}

	dirtVSpecBreakout = () => {
		let ret = []
		let model = {
			dirt: 0,
			spec: 0,
		}
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			if (!type || !community || !builder) {
				return
			}
			let path = `["${community.name}"]["${builder.name}"]["${type.name}"]`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				store[community.name][builder.name][type.name].spec++
			} else {
				store[community.name][builder.name][type.name].dirt++
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			if (!type || !community || !builder) {
				return
			}
			let path = `["${community.name}"]["${builder.name}"]["${type.name}"]`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				store[community.name][builder.name][type.name].spec--
			} else {
				store[community.name][builder.name][type.name].dirt--
			}
		})
		_.forEach(store, (builder, community) => {
			_.forEach(builder, (lotType, builderName) => {
				_.forEach(lotType, (v, typeName) => {
					ret.push({
						community,
						builder: builderName,
						lot_type: typeName,
						dirt: v.dirt,
						specs: v.spec,
					})
				})
			})
		})
		return ret
	}

	dirtCommunity = () => {
		let ret = []
		let model = {
			dirt: 0,
			spec: 0,
		}
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			if (!community) {
				return
			}
			let path = `["${community.name}"]`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				store[community.name].spec++
			} else {
				store[community.name].dirt++
			}
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			if (!community) {
				return
			}
			let path = `["${community.name}"]`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				store[community.name].spec--
			} else {
				store[community.name].dirt--
			}
		})
		_.forEach(store, (v, community) => {
			ret.push({
				community,
				dirt: v.dirt,
				specs: v.spec,
			})
		})
		return ret
	}

	floorplans = () => {
		let ret = []
		let columns = [
			{
				Header: "Floorplan",
				accessor: "floorplan",
				name: "Floorplan",
				display: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "floorplan"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				name: "Builder",
				display: true,
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Lot Type",
				accessor: "type",
				display: true,
				name: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "type"),
			},
			{
				Header: "Sale Count",
				accessor: "count",
				name: "Count",
				display: true,
			},
		]
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date || v.bustout_date) {
				return
			}
			let lt = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let floorplan = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			if (!floorplan || !builder || !lt) {
				return
			}
			let path = `["${lt.name}"]["${builder.name}"]["${floorplan.name}"]`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			store[lt.name][builder.name][floorplan.name]++
		})

		_.forEach(store, (v1, type) => {
			_.forEach(v1, (v, builder) => {
				_.forEach(v, (count, floorplan) => {
					ret.push({
						builder,
						floorplan,
						type,
						count,
					})
				})
			})
		})

		return (
			<>
				<h3>Floorplan Analysis</h3>
				<FullTable
					data={ret}
					columns={columns}
					name="salesAnalysis__floorplans"
					title="Floorplans"
					classNames={"small"}
					pageSize={40}
					defaultSorted={[
						{
							id: "count",
							desc: true,
						},
					]}
				/>
			</>
		)
	}

	homePrice = () => {
		let ret = []
		_.forEach(this.props.payload.exec.sales, (r) => {
			if (r.transfer_date) {
				return
			}

			// Filter by date range
			if (
				!r.sale_date ||
				r.sale_date < this.props.currentDates.startStamp ||
				r.sale_date > this.props.currentDates.endStamp
			) {
				return
			}

			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let lot = _.find(this.props.payload.exec.lots, { id: r.lot_id })
			let section = _.find(this.props.payload.public.sections, { id: lot?.section_id })
			let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })

			if (!builder || !lot) {
				return
			}

			let saleStatus = "Under Contract"
			if (r.closing_date) {
				saleStatus = "Closed"
			} else if (r.bustout_date || r.cancel_date) {
				return // Skip cancelled sales
			}

			let pricePerSf = 0
			if (r.sqft && r.price) {
				pricePerSf = Number((r.price / r.sqft).toFixed(2))
			}

			ret.push({
				lot_type: lotType?.name || "",
				builder: builder.name,
				lot: lot.lot || "",
				block: lot.block || "",
				section: section?.name || "",
				address: lot.address || "",
				sale_status: saleStatus,
				closing_date: r.closing_date || null,
				sale_price: r.price || 0,
				closing_price: r.closing_price || 0,
				home_sf: r.sqft || 0,
				price_per_sf: pricePerSf,
			})
		})
		return ret
	}

	lotSaleDetail = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (r) => {
			let section = _.find(this.props.payload.public.sections, { id: r.section_id })
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let f = {
				lot: r.lot,
				block: r.block,
				builder: builder ? builder.name : "",
				section: section ? section.name : "",
				address: r.address,
				takedown_date: r.takedown_date,
				start_date: r.start_date,
				complete_date: r.complete_date,
				buyer_name: r.buyer_name,
				buyer_email: r.buyer_email,
				buyer_zip: r.buyer_zip,
			}
			if (r.sale_id) {
				let sale = _.find(this.props.payload.exec.sales, { id: r.sale_id })
				let salesperson = _.find(this.props.payload.users, { id: sale.salesperson })
				if (sale) {
					f.sale_date = sale.sale_date
					f.sale_price = sale.price
					f.realtor_name = sale.realtor_name
					f.realtor_license = sale.realtor
					f.realtor_office = sale.realtor_office
					f.realtor_phone = sale.realtor_phone
					f.closing_date = sale.closing_date
					f.closing_price = sale.closing_price
					f.buyer_name = `${sale.primary_first} ${sale.primary_last}`
					f.buyer_email = sale.primary_email
					f.buyer_zip = sale.buyer_zip
					f.sales_rep = salesperson ? `${salesperson.first} ${salesperson.last}` : ""
				}
			}
			ret.push(f)
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="inventory">
					<div className="imageGroup">
						<Title title="Sales Analysis" />
						<div className="content inventory__content">
							<h3>Gross Sales</h3>
							<p className="small">Scroll to the right for Cancel and/or Closed dates.</p>
							<FullTable
								data={this.grossSupply()}
								columns={this.state.grossColumns}
								name="salesAnalysis__gross"
								title="GrossSales"
								classNames={"small"}
								pageSize={40}
							/>
						</div>
						<div className="content inventory__content">
							<h3>Sales Under Contract – No Closings</h3>
							<FullTable
								data={this.underContract()}
								columns={this.state.underContractColumns}
								name="salesAnalysis__underContract"
								title="UnderContract"
								classNames={"small"}
								pageSize={40}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Dirt vs. Spec Breakout</h3>
							<FullTable
								data={this.dirtVSpecBreakout()}
								columns={this.state.dirtBreakout}
								name="salesAnalysis__dirtBreakout"
								title="Dirt V Spec Breakout"
								classNames={"small"}
								pageSize={20}
							/>
							<h3>Dirt vs. Spec By Community</h3>
							<FullTable
								data={this.dirtCommunity()}
								columns={this.state.dirtCommunity}
								name="salesAnalysis__dirtCommunity"
								title="Dirt v Spec Community"
							/>
						</div>
					</div>
					<div className="content">
						<div className="imageGroup">
							<HomeSalesLotType />
							<HomeSalesBuilder />
							<HomeSalesLotTypeBuilder />
							<HomeSalesSectionBuilder />
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							{this.floorplans()}
							<h3>Home Price per SF Analysis</h3>
							<FullTable
								data={this.homePrice()}
								columns={this.state.homePriceColumns}
								name="salesAnalysis__homePriceSF"
								title="Home Price per SF Analysis"
								classNames={"small"}
								pageSize={40}
							/>
							<h3>Lot Sale Detail</h3>
							<FullTable
								data={this.lotSaleDetail()}
								columns={this.state.lotSaleDetail}
								name="salesAnalysis__lotSaleDetail"
								title="Lot Sale Detail"
								classNames={"small"}
								pageSize={20}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SalesAnalysis)
